
define(
	'Code25.CaterpartsGlobal.App.View'
	, [
		"Handlebars", "Utils", "Code25.app.tpl", "Tools", 'js.cookie'
	]
	, function (
		Handlebars, Utils, Code25_app_tpl, Tools, Cookies
	) {
		'use strict';


		var slideIn

		return Backbone.View.extend({

			template: Code25_app_tpl,
			initialize: function (options) {

			},
			close: function (e) {
				e.stopPropagation();
				e.preventDefault();
				Cookies.set('AD', "X", { expires: 31 });
				this.render();
			}
			, events: {
				'click [data-action="close"]': 'close',
			},
			getContext: function getContext() {
				var isApp = Tools.isApp();

				var hide = Cookies.get('AD') == "X";

				var isApple = /iPhone|iPad|iPod/i.test(navigator.userAgent);
				var isAndroid = /Android/i.test(navigator.userAgent);

				
				var active = slideIn;
				if (!slideIn) {

					setTimeout(function () {
						var appdownload = document.getElementById("appdownload");
						if (appdownload) {
							appdownload.className += "active";
							slideIn = true;
						}
					}, 2000);


				}

				return {
					show: !isApp && !hide && (isApple || isAndroid),
					store: isAndroid ? "android" : "apple",
					active: active
				};
			}
		});

	});



